import React from 'react';

interface CustomIconProps {
  filled?: boolean;
  color?: string;
  width?: string;
  height?: string;
}

const DiplomaIcon: React.FC<CustomIconProps> = ({ width, height }) => (
  <svg
    width={width ?? '28'}
    height={height ?? '24'}
    viewBox='0 0 28 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M27.3333 18.6667V1.19209e-06L0.666657 0L0.666656 18.6667L10.6667 18.6667H12.6242C12.2251 17.8634 12 16.9576 12 16C12 12.6863 14.6863 10 18 10C21.3137 10 24 12.6863 24 16C24 16.9576 23.7749 17.8634 23.3758 18.6667H27.3333ZM5.24999 4.58333H5.99999H22H22.75V6.08334H22H5.99999H5.24999V4.58333ZM5.99999 9.91667H5.24999V11.4167H5.99999H9.99999H10.75V9.91667H9.99999H5.99999ZM22 16C22 17.1847 21.485 18.249 20.6667 18.9815V24L18 22.6667L15.3333 24V18.9815C14.515 18.249 14 17.1847 14 16C14 13.7909 15.7909 12 18 12C20.2091 12 22 13.7909 22 16Z'
      fill='white'
    />
  </svg>
);

export default DiplomaIcon;
